import React, { useEffect, useState } from "react";
import configData from "../../../temp/config";
import { withTranslation } from "react-i18next";

const WeightGainCalculatorResult = (props) => {
    let componentData = props.componentData;
    let weightGainCalculatorData = props.WeightGainCalculatorData;
    const [errorResponseText, setErrorResponseText] = useState("");
    const [domain, setDomain] = useState("");

    useEffect(() => {
        setDomain(configData.sitecoreApiHost);
        setErrorResponseText(weightGainCalculatorData?.error ? weightGainCalculatorData?.error : "");
        // const { t } = props; // for dictionary phrases
    }, [weightGainCalculatorData]);

    const Result = () => {
        return (
            <div className="results-block">
                <div className="results-head">
                    <div className="text-center">
                        {/* <h3 className="text-brand-recommended">
                        {t("DiaperSizeCalculator_Recommended")}
                        </h3> */}
                        <div className="brand-image">
                            {componentData?.ResultIcon?.value != null && (
                                <img
                                    src={
                                        domain +
                                        componentData?.ResultIcon?.value?.src
                                    }
                                    alt=""
                                    srcSet=""
                                    loading="lazy"
                                />
                            )}
                        </div>
                        <h1>
                            {componentData?.ResultDescription?.value}{" "}
                            {weightGainCalculatorData?.apiData?.resultWeek}
                        </h1>
                        <p className="text-brand-size">
                            {
                                weightGainCalculatorData?.apiData
                                    ?.resultWeightGain
                            }
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            {props != null && errorResponseText === "" && <Result />}
            {errorResponseText !== "" && (
                <div className="results-block">
                    <div className="results-head">
                        <div className="content">
                            <p>{errorResponseText}</p>
                        </div>
                    </div>
                </div>
            )}
        </>
    );

}

export default withTranslation()(WeightGainCalculatorResult);